module.exports = __webpack_public_path__ + "img/greatgrammar.ca9ec27d.png";